/**
 * Natolie — flechas del selector de color con fotos.
 *
 * Muestra/oculta las flechas segun haya contenido fuera de la vista, desplaza una
 * "pagina" de tarjetas al pulsarlas, y centra la tarjeta seleccionada al elegir un color.
 * No interviene en el cambio de variante: de eso sigue encargandose el tema.
 */
(() => {
  const TRACK = '[data-nt-cards-track]';

  /** @param {HTMLElement} viewport */
  const refreshArrows = (viewport) => {
    const track = viewport.querySelector(TRACK);
    if (!track) return;

    const prev = viewport.querySelector('[data-nt-cards-arrow="prev"]');
    const next = viewport.querySelector('[data-nt-cards-arrow="next"]');
    // 2px de margen para evitar parpadeos por redondeos de subpixel.
    const maxScroll = track.scrollWidth - track.clientWidth - 2;

    if (prev) prev.hidden = maxScroll <= 0 || track.scrollLeft <= 2;
    if (next) next.hidden = maxScroll <= 0 || track.scrollLeft >= maxScroll;
  };

  /** @param {HTMLElement} viewport */
  const setup = (viewport) => {
    if (viewport.dataset.ntCardsReady === 'true') return;
    viewport.dataset.ntCardsReady = 'true';

    const track = viewport.querySelector(TRACK);
    if (!track) return;

    track.addEventListener('scroll', () => refreshArrows(viewport), { passive: true });

    viewport.querySelectorAll('[data-nt-cards-arrow]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = track.querySelector('[data-nt-card]');
        const step = card ? card.getBoundingClientRect().width * 2 : track.clientWidth * 0.8;
        const direction = button.dataset.ntCardsArrow === 'prev' ? -1 : 1;

        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      });
    });

    // Al elegir un color, deja su tarjeta a la vista.
    track.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.checked) return;

      // Estilo miniatura: pone el nombre del color elegido junto al título ("Color : Blanco").
      const value = input.closest('fieldset')?.querySelector('[data-nt-cards-value]');
      if (value) value.textContent = ` : ${input.value}`;

      input.closest('[data-nt-card]')?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => refreshArrows(viewport)).observe(track);
    }

    refreshArrows(viewport);
  };

  const setupAll = () => document.querySelectorAll('.nt-cards__viewport').forEach(setup);

  document.addEventListener('DOMContentLoaded', setupAll);
  setupAll();

  // El tema vuelve a pintar el selector al cambiar de variante: hay que reenganchar.
  new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
})();
